import { Link } from '@doist/marketist'

import { Interpolate } from 'components'
import { VideoFeature } from 'components/VideoFeatureSection/VideoFeature'
import { VideoFeatureProvider } from 'components/VideoFeatureSection/VideoFeatureProvider'
import { useTranslation } from 'next-i18next'

import { appendSlackAltUTM } from '../appendSlackAlternativeUTM'

export function SlackVideoFeature() {
    const { t } = useTranslation('slackalternative')

    return (
        <VideoFeatureProvider>
            <VideoFeature
                title={t('featureThreads.title')}
                body={t('featureThreads.body')}
                videoPath="/assets/home/videos/threads-220421.mp4"
                poster="/assets/home/videos/poster-image_messages-220421.jpg"
            />
            <VideoFeature
                title={t('featureMessages.title')}
                body={
                    <Interpolate
                        i18nKey="featureMessages.body"
                        t={t}
                        mapping={{
                            link: <Link href={appendSlackAltUTM('/customer-stories')} />,
                        }}
                    />
                }
                videoPath="/assets/home/videos/messages-220421.mp4"
                poster="/assets/home/videos/poster-image_messages-220421.jpg"
            />
            <VideoFeature
                title={t('featureCloseThreads.title')}
                body={t('featureCloseThreads.body')}
                videoPath="/assets/home/videos/history.mp4"
                poster="/assets/home/videos/poster-image_history.jpg"
            />
        </VideoFeatureProvider>
    )
}
